import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner"
import { MatAutocompleteSelectedEvent, MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { TableUtil } from '../admintrademaster/tableUtil';

@Component({
    selector: 'app-loginlogs',
    templateUrl: './loginlogs.component.html',
    styleUrls: ['./loginlogs.component.css']
})
export class LoginLogsComponent implements OnInit {
    displayedColumns: string[] = ['ipaddress', 'user_name', 'action_name', 'model', 'agent', 'description', 'createdAt',];
    dataSource = new MatTableDataSource<any>([]);
    filteredDataSource = new MatTableDataSource<any>([]);
    pageSize = 25;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    users;
    clients: any[] = [];
    clientListSearchCopy: any[] = [];
    selectedClientValue: boolean = true;

    filter: any = {
        fromDate: moment().subtract(3, 'd').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
    };
    constructor(private router: Router,
        private userService: UserService,
        private spinnerService: Ng4LoadingSpinnerService,
        ) { }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {

            this.getAdminloginActivity();
            this.getClients()
        }
    }

    fromDateFilter(event: MatDatepickerInputEvent<Date>) {
        if (event.value) {
            console.log(event.value, 'event value');
            this.filter['fromDate'] = moment(event.value).format('YYYY-MM-DD');
        }
    }
    applyFilter(filterValue: string): void {
        console.log(filterValue, 'filtervalue');
        const trimmedValue = filterValue.trim().toLowerCase();
        console.log(trimmedValue, 'trimmedvalue')
        this.dataSource.filter = trimmedValue;
        console.log(this.dataSource.filter, 'this.dataSource.filter')
    }
    exportArray() {
        if (this.dataSource.filteredData) {
            const logArr = this.dataSource.filteredData.map(x => ({
                ipaddress: x.ipaddress,
                user_name: x.user_name,
                action_name: x.action_name,
                model: x.model,
                agent: x.agent,
                description: x.description,
                createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(logArr, "logArr");
        }

    }
    toDateFilter(event: MatDatepickerInputEvent<Date>) {
        if (event.value) {
            this.filter['toDate'] = moment(event.value).format('YYYY-MM-DD');
        }
    }

    // Convert stored date string back to Date object
    getParsedDate(dateString: string): Date | null {
        return dateString ? new Date(dateString) : null;
    }
    getAdminloginActivity() {
        this.spinnerService.show();
        this.userService.getLoginAllActivityList(this.filter).subscribe(
            (list: any) => {
                const logRes = list.logs.map((l: any) => {
                    l.user_name = l.userid && l.userid.name ? l.userid.name : '--';
                    l.createdAt = moment(l.createdAt).format('MM/DD/YY h:mm:ss A');
                    return l;
                });
                this.dataSource = new MatTableDataSource(logRes);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.spinnerService.hide();
            }
        );
    }

    getClients() {
        this.userService.getClients().subscribe(clients => {
            this.users = clients
            clients = clients.map(function (item) {
                return { clientName: item.name };
            })
            this.clients = clients.map(list => list.clientName)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.clientListSearchCopy = this.clients;
        })
    }
    filterWithClient(event: any) {
        let term = event;
        this.clients = this.clientListSearchCopy.filter(function (tag) {
            if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        this.selectedClientValue = false;
        const selectedValue = event.option.value;
        const result = this.users.find(user => user.name === selectedValue);
        if (selectedValue === 'ALL') {
            this.filter['UserId'] = selectedValue
        } else this.filter['UserId'] = result._id;
    }

}



// WEBPACK FOOTER //
// ./src/app/loginlogs/loginlogs.component.ts